<template>
  <div>
    <jm-upload
      v-bind="$attrs"
      :action="url"
      :multiple="multiple"
      :before-upload="beforeUpload"
      :on-success="handleAvatarSuccess"
      :on-remove="handleRemove"
      :on-error="handleError"
      :on-preview="handlPreview"
      :data="uploadMergeData()"
      :file-list="fileList"
      :show-file-list="showFileList"
    >
      <slot name="uploadFile">上传</slot>
    </jm-upload>
  </div>
</template>
<script>
const countrySchoolOfferId = {
  country_id: 485,
  offer_school_id: 0,
  offer_id: 0,
};
export default {
  name: 'JmUploadFileOfTask',
  props: {
    /*
      * 是否支持多文件上传
      * */
    multiple: {
      type: Boolean,
      default: false,
    },
    /*
      * 上传Url
      * */
    url: {
      type: String,
      default: '',
    },
    /*
      * 上传后 是否显示列表
      * */
    showFileList: {
      type: Boolean,
      default: true,
    },
    /*
      * 上传 请求数据
      * */
    uploadData: {
      type: Object,
      default() {
        return {};
      },
    },
    /*
      * 上传 请求数据 特殊 以属性输入 在进行合并
      * */
    uploadAdditional: {
      type: Object,
      default() {
        return {};
      }
    },
    /*
      * 是否自动保存 页面数据  传入父组件方法进行调用
      * */
    isFunction: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      fileList: [],
    };
  },
  mounted() {
    if (this.uploadData.crm_id) {
      this.getUploadInfo();
    }
  },
  methods: {
    beforeUpload(file) {
      let maxSize = 1024 * 1024 * 4;
      if (file === null) {
        this.$message.error('没有文件,请选择文件！');
        return false;
      } else if (file.size > maxSize) {
        this.$message.error('文件大小不能超过4M!');
        return false;
      }
    },
    /*
      * 初始化上传数据
      * */
    getUploadInfo() {
      if (this.showFileList) {
        this.$http._post({
          url: '/index/apply_file/index',
          data: this.uploadMergeData()
        }).then(({ data }) => {
          data.forEach((item) => {
            if (item.file_list) {
              item.file_list = item.file_list.map((f) => {
                let url = this.uploadMergeData().country_id !== 0 ?
                  f :
                  decodeURIComponent(decodeURIComponent(f.substring(f.lastIndexOf('/') + 1)));
                let s = decodeURIComponent(decodeURIComponent(f));
                let name = s.substring(s.lastIndexOf('/') + 1);
                let index = name.lastIndexOf('____');
                name = index !== -1 ? name.substring(name.lastIndexOf('____') + 4) : name;
                return {
                  name: name,
                  download: f,
                  url: url
                };
              });
            }
            this.fileList = item.file_list;
          });
        });
      }
    },
    /*
      * 上传成功钩子
      * */
    handleAvatarSuccess(file) {
      if (typeof this.isFunction === 'function') {
        this.isFunction();
      }
      if (file.result !== -1) {
        this.$message.success('上传成功');
        this.getUploadInfo();
        this.$emit('upload-get-info', true);
      } else {
        this.$message.error(file.msg);
      }
    },
    /*
      * 删除钩子
      * */
    handleRemove(file) {
      if (file.status === 'success' && this.showFileList) {
        let data1 = {};
        Object.assign(data1, this.uploadMergeData(), { file_url: file.url });
        this.$http._post({
          url: '/index/apply_file/deleteFile',
          data: data1
        }).then(({ data }) => {
          if (data.result !== -1) {
            this.getUploadInfo();
            this.$message.success('删除成功');
          }
        });
      }
    },
    /*
      * 点击下载
      * */
    handlPreview(file) {
      console.log(file);
      window.open(`${file.download}?${file.uid}`);
    },
    /*
      * 数据合并
      * */
    uploadMergeData() {
      let data1 = {};
      let data2 = countrySchoolOfferId;
      Object.assign(data1, data2, this.uploadAdditional, this.uploadData);
      return data1;
    },
    /**
       * description: 错误提示处理
       * Data: 2017/9/13 15:30
       * Author: yanlichen <yanlichen@tuozhongedu.com>
       */
    handleError(error) {
      let message = error.message.substring(error.message.indexOf('{'));
      message = JSON.parse(message);
      this.$message.error(message.msg);
    },
  },
};
</script>
